
import { BrowserStorageService, ServiceManager, ServiceType, API, Config } from 'client-website-ts-library/services';
import { Component, Vue } from 'vue-property-decorator';
import { Office, OfficeExternalLinkType } from 'client-website-ts-library/types';

import Navigation from './Navigation.vue';

@Component({
  components: {
    Navigation,
  },
})
export default class Header extends Vue {
    private selectedOffice: string | null = null;

    private office: Office | null = null;

    private isStuck = false;

    private mobileNavActive = false;

    /* Configuration Options */
    private gradient = false;

    private fixed = false;

    private stickyNav = true;

    private eventListenerOpts: AddEventListenerOptions | EventListenerOptions = { passive: true };

    get facebookLink(): string | undefined {
      return this.office?.ExternalLinks.find(
        (l) => l.Type === OfficeExternalLinkType.Facebook
      )?.Url;
    }

    // @click.prevent="scrollToFooterForm"
    // scrollToFooterForm() {
    //   const el = document.getElementById('subscribe-form');
    //   if (el) {
    //     el.scrollIntoView({ behavior: 'smooth' });
    //   }
    // }

    mounted() {
      this.checkScroll();

      this.$router.afterEach(() => {
        this.mobileNavActive = false;
      });

      API.Offices.Get(Config.Website.Settings!.WebsiteId).then((office) => {
        this.office = office;
      });
    }

    checkScroll(): void {
      this.isStuck = window.scrollY > 0;
    }

    created() {
      window.addEventListener('scroll', this.checkScroll, this.eventListenerOpts);
    }

    beforeDestroy() {
      window.removeEventListener('scroll', this.checkScroll, this.eventListenerOpts);
    }
}
